import React from 'react'
import { Icon } from '../../../../../atoms/Icon'
import { FilterChip } from '../../../../../molecules/FilterDisplay'
import { FilterSelect } from '../../../../../molecules/FilterPanel/FilterFormComponents'
import {
  RadiusFilterBar,
  RadiusFilters,
  RadiusBadge,
} from '../NeighborhoodContextTab.styles'
import { RADIUS_OPTIONS } from '../NeighborhoodContextTab.constants'
import type { RadiusSelectorProps } from '../NeighborhoodContextTab.types'

export const RadiusSelector: React.FC<RadiusSelectorProps> = ({
  selectedRadius,
  onRadiusChange,
  t,
}) => (
  <RadiusFilterBar>
    <RadiusFilters>
      <FilterChip active={true}>
        <Icon name="target" size="small" />
        {t('neighborhood.radius.label')}
      </FilterChip>
      <FilterSelect
        value={selectedRadius.toString()}
        onChange={(value) => {
          const parsed = parseInt(value, 10)
          if (Number.isFinite(parsed)) onRadiusChange(parsed)
        }}
        options={RADIUS_OPTIONS}
      />
      <RadiusBadge>
        <Icon name="map-pin" size="small" />
        {t('neighborhood.radius.value', {
          value: selectedRadius,
        })}
      </RadiusBadge>
    </RadiusFilters>
  </RadiusFilterBar>
)
